import React from "react";
import Homebutton from "./Homebutton";
import Header from "./HomeHeader";
import Footer from "./Footer"
import "../App.css"
import "./HomePage.css"
import Hero from "../images/hero.PNG"
import truck from "../images/truck.png"
import { Helmet } from "react-helmet";
import { useRef } from "react";
import { useState } from "react";
import { FadeLoader } from "react-spinners" ;
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { sendQueryForUs, updateVisit } from "../service/api";
import { useEffect } from "react";

export default function HomePage() {

  const emailRef=useRef();
  const nameRef=useRef();
  const queryRef=useRef();
  const contactRef=useRef();
  const [openSnackBar,setOpenSnackBar]=useState(false);
  const [severity,setSeverity]=useState("");
  const [msg,setMsg]=useState("");
  const [loading, setLoading] = useState(false);
  const [others,setOthers] =useState('none');

  useEffect(()=>{
    updateVisit();
  })
  async function sendEmail(e){
    e.preventDefault();
    if(!validateEmail(emailRef.current.value)){
      alert("Invalid Email Address");
    }
    if(!validatePhone(contactRef.current.value)){
      alert("Invalid Phone Number");
    }
    if(validateEmail(emailRef.current.value) && validatePhone(contactRef.current.value)){
      try{
        setLoading(true);
        setOthers('block');
        let response=await sendQueryForUs({name: nameRef.current.value,
          email_from: emailRef.current.value,
          message: queryRef.current.value,
          phoneNo: contactRef.current.value})

          if(response){ 
          setLoading(false);
          setOthers('none');
          setOpenSnackBar(true);
          setSeverity("success");
          setMsg("Query has been sent. We will return to you!");
          }
          else{
            setLoading(false);
            setOthers('none');
            setOpenSnackBar(true);
            setSeverity("success");
            setMsg("Failed to send the query. Try again!");
          }
      }
      catch(err){
        setLoading(false);
        setOthers('none');
        setOpenSnackBar(true);
        setSeverity("success");
        setMsg(err);
      }
      // emailjs.send("service_haxbxbn","template_96qzk8a",{
      //   name: nameRef.current.value,
      //   email_from: emailRef.current.value,
      //   message: queryRef.current.value,
      //   phoneNo: contactRef.current.value
      //   },'user_69DDl1S4TLSuI5oZM5zNS') 
      //   .then(res=>{
      //     console.log(res);
      //   }).catch(err=>console.log("Error: "+err));

      var frm=document.getElementsByName("mail-form")[0];
      frm.reset();
        alert("Query submitted successfully");
    }
  }
  function validatePhone(num){
   if(num.length==10){
    return true;
   }
   else{
    return false;
   }
  }
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };

  return (
    <>
      <div className="LoadingScreen" style={{display:others}}>
        <div className="loader">
          <FadeLoader color={"#B8B8B8"} loading={loading} size={150}/>
        </div>
      </div>
      <Helmet>
        <title>Transit Pro</title>
      </Helmet>
      <Header/> 
      <div className="biggerPicture"> 
      <div className="divide">
      <div className='Heroleft'>
        <h1 className="hero-H">Businesses Grow With</h1>
    <img src={Hero} alt="Transit Pro" className="banner" />
    <p>This is a platform where your Logistic Companies find their Future Businesses. </p>
        <Homebutton/>
        
        <img src={truck} alt="Truck" className="truck-gr"/>
      </div>
   
      <div className="HeroRight">
         <h2>Contact Us</h2>
           <form onSubmit={sendEmail} name="mail-form">
             <div className="login">
             <input type="text" required className="input" id="name" ref={nameRef} placeholder="Your Name"/>
             <input type="text" required className="input" id="mail" ref={emailRef} placeholder="Your Email"/>
            </div>
            <div className="subject">
             <input type="number" required className="input" id="number" ref={contactRef} placeholder="Your Mobile Number" />
            </div>
            <div className="msg">
             <textarea name="Message" required className="area" id="msg"  ref={queryRef} placeholder="Your Queries"/>
            </div>
            <div className="submit">
             <button type="submit ">Send Message</button>
            </div>
           </form>
         </div>
      </div>
      </div>
      
      <Footer/>
      <Snackbar
        anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
        open={openSnackBar}
        autoHideDuration={8000}
        onClose={handleClose}
        >
        <Alert onClose={handleClose} severity={severity}>
            {msg}
        </Alert>
      </Snackbar>
      
    </>

  );
}
